export const en = {
    pageHeader: 'Profile of expert: {fullName}',
    saveError: 'Unable to update the profile, please try again later.'
};
